<div class="pt-context-menu-anchor" [style.left.px]="x" [style.top.px]="y" [matMenuTriggerFor]="root.menu"
  [matMenuTriggerRestoreFocus]="false"></div>

<app-context-submenu #root [items]="items" (closed)="onMenuClosed()"></app-context-submenu>
